import React from "react";

import { FilterIcon as Filter } from "@packages/ds";
import { useIntl } from "react-intl";

import * as S from "./styles";
import ToggleLayout from "./ToggleLayout";

type Props = {
  sortTypes: Array<{ id: string; ascend: string; descend: string }>;
  toggleLayout: (value: boolean) => void;
  gridLayout: boolean;
  sortType: string;
  setSortType: (value: string) => void;
  sortOrder: string;
  setSortOrder: (value: string) => void;
  shouldShowFilters: boolean;
  onShowFiltersClick: () => void;
  numberOfProjects: number | undefined;
};

const ProjectFilterBar = ({
  toggleLayout,
  gridLayout,
  sortType,
  setSortType,
  sortOrder,
  setSortOrder,
  sortTypes,
  shouldShowFilters,
  onShowFiltersClick,
  numberOfProjects
}: Props) => {
  const intl = useIntl();
  return (
    <S.Wrapper>
      <S.ProjectPageTitle tag="h2">
        {intl.formatMessage({
          id: "projects.filter.all",
          defaultMessage: "All projects"
        })}
        {numberOfProjects !== undefined ? ` (${numberOfProjects})` : null}
      </S.ProjectPageTitle>
      <S.FiltersWrapper>
        <S.ShowFiltersToggle
          toggleType="text"
          layout="list"
          text={
            <>
              {intl.formatMessage({
                id: shouldShowFilters
                  ? "projects.hide_filter"
                  : "projects.show_filter"
              })}
              <Filter />
            </>
          }
          onPressedChange={() => {
            onShowFiltersClick();
          }}
        />
        <ToggleLayout
          sortTypes={sortTypes}
          toggleLayout={toggleLayout}
          gridLayout={gridLayout}
          sortType={sortType}
          setSortType={setSortType}
          sortOrder={sortOrder}
          setSortOrder={setSortOrder}
        />
      </S.FiltersWrapper>
    </S.Wrapper>
  );
};

export default ProjectFilterBar;
